import Singapore from "../../assets/logo/country/singapore.png";
import UK from "../../assets/logo/country/uk.png";
import Australia from "../../assets/logo/country/australia.png";
import PSB from "../../assets/images/psb-academy.webp";
import Kaplan from "../../assets/images/kaplan-singapore.webp";
import Amity from "../../assets/images/amity-global-institute.webp";
import EAIM from "../../assets/images/eaim.webp";
import MDIS from "../../assets/images/mdis-singapore.webp";
import Teesside from "../../assets/images/teesside-university.webp";
import UOSW from "../../assets/images/university-of-south-wales.webp";
import UOS from "../../assets/images/university-of-sunderland.webp";
import UWE from "../../assets/images/uwe-bristol.webp";
import UOH from "../../assets/images/university-of-huddersfield.webp";
import UON from "../../assets/images/university-of-northampton.webp";
import Coventry from "../../assets/images/coventry-university.webp";

export const featuredUniversities = [
  {
    id: 1,
    image: PSB,
    name: "PSB Academy",
    country: "Singapore 🇸🇬",
    description:
      "PSB Academy is a private education institution in Singapore offering a range of diploma, undergraduate, and postgraduate programs in business, IT, engineering, and health sciences, often in partnership with international universities.",
    scholarship: "Merit Scholarships",
    color: "from-blue-400 to-cyan-500",
  },
  {
    id: 2,
    image: Amity,
    name: "Amity Global Institute",
    country: "Singapore 🇸🇬",
    description:
      "Amity Global Institute is a private education provider in Singapore offering business, IT, and management programs in partnership with international universities.",
    scholarship: "Up to 30% Scholarship",
    color: "from-indigo-400 to-blue-500",
  },
  {
    id: 3,
    image: Teesside,
    name: "Teesside University",
    country: "United Kingdom 🇬🇧",
    description:
      "Teesside University is a UK-based university known for industry-focused programs in business, computing, engineering, health, and creative arts, emphasizing employability and practical learning.",
    scholarship: "Merit & Need-Based",
    color: "from-red-400 to-pink-500",
  },
  {
    id: 4,
    image: Coventry,
    name: "Coventry University",
    country: "United Kingdom 🇬🇧",
    description:
      "Coventry University is a UK university renowned for its industry-focused programs, strong employability outcomes, and global partnerships across business, engineering, health, and creative disciplines.",
    scholarship: "Early Bird Scholarships",
    color: "from-purple-400 to-indigo-500",
  },
];

export const destinations = [
  {
    country: "Singapore",
    flag: Singapore,
    description: "Fast-track programs, strong job market, and close to home.",
    universities: "PSB, Kaplan, Amity",
    color: "from-red-400 to-pink-500",
  },
  {
    country: "United Kingdom",
    flag: UK,
    description:
      "1-year master's, 3-year degree programs, world-recognised qualifications.",
    universities: "Teesside, Coventry, Sunderland",
    color: "from-blue-400 to-indigo-500",
  },
  // {
  //   country: "Australia",
  //   flag: Australia,
  //   description:
  //     "Easy transition, friendly for Malaysians, and great post-study work rights.",
  //   universities: "Melbourne, Monash, Sydney",
  //   color: "from-teal-400 to-cyan-500",
  // },
];

export const benefits = [
  {
    title: "Higher Scholarships",
    description:
      "Merit-based & early-bird scholarships available for selected universities.",
    emoji: "🏆",
  },
  {
    title: "Extra Rebate",
    description:
      "Exclusive rebates for SCS Education applicants (varies by university).",
    emoji: "💰",
  },
  {
    title: "Fast Application",
    description:
      "Submit documents once — we handle the rest and process everything quickly.",
    emoji: "⚡",
  },
  {
    title: "Visa & Accommodation Support",
    description:
      "End-to-end guidance for visa, pre-departure briefing, and accommodation.",
    emoji: "✈️",
  },
  {
    title: "Trusted Overseas Application Partner",
    description: "Proven track record with thousands of successful placements.",
    emoji: "🌟",
  },
  {
    title: "Fast & Personalized Guidance",
    description:
      "We understand your results, preferences, and goals — then match you with the right university.",
    emoji: "🎯",
  },
  {
    title: "Zero Charges",
    description: "Our counselling service is 100% FREE for students.",
    emoji: "🆓",
  },
  {
    title: "End-to-End Support",
    description:
      "Application, visa, accommodation, scholarship — everything done for you.",
    emoji: "🤝",
  },
];

export const testimonials = [
  {
    name: "Chai Jiong Xian",
    destination: "United Kingdom 🇬🇧",
    quote:
      "They've been with me every step of the way, making the process smooth and stress-free. Here's to a bright future, thanks to SCS Education!",
    uni: "University of Sunderland",
    color: "bg-gradient-to-br from-teal-100 to-cyan-100",
  },
  {
    name: "Anonymous",
    destination: "Singapore 🇸🇬",
    quote:
      "Thank you SCS Dolly recommended me to go Singapore study, and I get scholarships too! Highly recommend SCS to every students!",
    uni: "",
    color: "bg-gradient-to-br from-red-100 to-pink-100",
  },
  {
    name: "Tan Jun An",
    destination: "United Kingdom 🇬🇧",
    quote:
      "I am saying thanks to each and every staff in SCS Education for their kindness and care. You are really awesome!!!",
    uni: "UWE Bristol",
    color: "bg-gradient-to-br from-blue-100 to-indigo-100",
  },
];

export const faqs = [
  {
    question: "How do I apply to overseas universities?",
    answer:
      "Just send us your SPM/UEC results. We will shortlist universities and guide you through the entire process.",
  },
  {
    question: "Are your counselling services free?",
    answer: "Yes — SCS Education provides 100% free support for all students.",
  },
  {
    question: "What documents do I need?",
    answer:
      "SPM/UEC results, passport copy, school leaving cert, and transcripts (if applicable).",
  },
  {
    question: "How long does the process take?",
    answer: "Some universities issue an offer within 3–10 working days.",
  },
  {
    question: "Do I need to choose my course first?",
    answer:
      "Not necessarily — we'll help you explore options based on your interests and results.",
  },
];

export const overseasUniversities = [
  {
    name: "PSB",
    image: PSB,
    fullName: "PSB Academy",
    location: "Singapore",
    ranking: "#22 in Singapore",
    scholarships: "5 Scholarships",
    employment: "85% Graduate Employment Rate",
    description:
      "PSB Academy is a private education institution in Singapore offering a range of diploma, undergraduate, and postgraduate programs in business, IT, engineering, and health sciences, often in partnership with international universities.",
    courses: [
      { name: "Diploma in Business Administration", fee: "SGD 7,673" },
      { name: "Diploma in Sport & Exercise Sciences", fee: "SGD 7,673" },
      { name: "Media / Communication‑related Diploma", fee: "SGD 7,673" },
    ],
    color: "from-blue-400 to-cyan-500",
  },
  {
    name: "Kaplan",
    image: Kaplan,
    fullName: "Kaplan International Pathway Singapore",
    location: "Singapore",
    ranking: "Global Recognized",
    scholarships: "7 Scholarships",
    employment: "70% Graduate Employment Rate",
    description:
      "Kaplan Singapore is a private education institution offering diploma, undergraduate, and postgraduate programs in partnership with international universities, covering fields like business, IT, accounting, law, and psychology.",
    courses: [
      { name: "Diploma in Psychology", fee: "SGD 7,466" },
      { name: "Diploma in Accounting & Finance", fee: "SGD 6,540" },
      { name: "Diploma in Finance & Business Analytics", fee: "SGD 5,450" },
    ],
    color: "from-indigo-400 to-blue-500",
  },
  {
    name: "Amity",
    image: Amity,
    fullName: "Amity Global Institute",
    location: "Singapore",
    ranking: "No 1 UK MBA in Singapore",
    scholarships: "8 Scholarships",
    employment: "75% Graduate Employment Rate",
    description:
      "Amity Global Institute is a private education provider in Singapore offering business, IT, and management programs in partnership with international universities.",
    courses: [
      { name: "Diploma in Business Management", fee: "SGD 7,500" },
      { name: "Diploma in Accounting & Finance", fee: "SGD 7,500" },
      { name: "Diploma in Computing / IT", fee: "SGD 7,500" },
      {
        name: "Diploma in Hospitality / Hospitality & Tourism Management",
        fee: "SGD 6,000",
      },
    ],
    color: "from-red-400 to-pink-500",
  },
  {
    name: "EAIM",
    image: EAIM,
    fullName: "East Asia Institute of Management",
    location: "Singapore",
    ranking: "Globally-Linked Business Education",
    scholarships: "10 Scholarships",
    employment: "95% Graduate Employment Rate",
    description:
      "East Asia Institute of Management (EAIM) is a private Singapore institution known for affordable business-focused programmes delivered through UK university partnerships.",
    courses: [
      { name: "Diploma in Business and Management", fee: "SGD 6,280" },
      { name: "Diploma in Business and Accounting", fee: "SGD 6,280" },
      {
        name: "Diploma in International Hospitality & Tourism Management",
        fee: "SGD 6,280",
      },
      { name: "Advanced Diploma", fee: "SGD 7,310" },
    ],
    color: "from-purple-400 to-indigo-500",
  },
  {
    name: "MDIS",
    image: MDIS,
    fullName: "Management Development Institute of Singapore",
    location: "Singapore",
    ranking: "Modest global standing.",
    scholarships: "6 Scholarships",
    employment: "78% Graduate Employment Rate",
    description:
      "MDIS (Management Development Institute of Singapore) is a long-established private institution offering business, media, IT, health sciences, and hospitality programs in partnership with international universities.",
    courses: [
      {
        name: "Diploma / Advanced Diploma in Business & Management",
        fee: "SGD 7,900",
      },
      { name: "Hospitality & Tourism Management", fee: "SGD 6,700" },
      { name: "Media, Communication & Creative", fee: "SGD 32,000" },
      { name: "Engineering / Technology / IT", fee: "SGD 40,000" },
    ],
    color: "from-teal-400 to-cyan-500",
  },
  {
    name: "Teesside",
    image: Teesside,
    fullName: "Teesside University",
    location: "United Kingdom",
    ranking: "#601-800 QS World",
    scholarships: "7 Scholarships",
    employment: "95% Graduate Employment Rate",
    description:
      "Teesside University is a UK-based university known for industry-focused programs in business, computing, engineering, health, and creative arts, emphasizing employability and practical learning.",
    courses: [
      { name: "Business & Management", fee: "GBP 17,000" },
      { name: "Computing / IT / Engineering", fee: "GBP 17,000" },
      { name: "Postgraduate Programmes", fee: "GBP 17,000" },
      { name: "Foundation / Pathway Courses", fee: "GBP 15,500" },
    ],
    color: "from-orange-400 to-red-500",
  },
  {
    name: "USW",
    image: UOSW,
    fullName: "University of South Wales",
    location: "United Kingdom",
    ranking: "#51 in UK",
    scholarships: "8 Scholarships",
    employment: "96% Graduate Employment Rate",
    description:
      "University of South Wales (USW) is a UK university offering a wide range of undergraduate and postgraduate programs, emphasizing practical skills and industry connections across business, engineering, creative arts, and health sciences.",
    courses: [
      { name: "Business / Creative Industries", fee: "GBP 15,850" },
      {
        name: "Computing / Engineering / Sciences / Educatione",
        fee: "GBP 16,200",
      },
      { name: "Law / Legal Studies / Law‑related fields", fee: "GBP 16,900" },
      { name: "Postgraduate Degrees", fee: "GBP 16,900" },
    ],
    color: "from-violet-400 to-purple-500",
  },
  {
    name: "UOS",
    image: UOS,
    fullName: "University of Sunderland",
    location: "United Kingdom",
    ranking: "#27 in UK",
    scholarships: "9 Scholarships",
    employment: "95% Graduate Employment Rate",
    description:
      "University of Sunderland is a UK-based institution offering a wide range of undergraduate and postgraduate programs with strong emphasis on employability, practical skills, and international partnerships.",
    courses: [
      {
        name: "Business / Management / Accounting & Finance",
        fee: "GBP 16,500",
      },
      {
        name: "Computing / IT / Engineering / Computer Science",
        fee: "GBP 16,500",
      },
      {
        name: "Health / Nursing / Allied Health‑Related Degrees",
        fee: "GBP 16,500",
      },
      { name: "Postgraduate Programmes", fee: "GBP 17,000" },
    ],
    color: "from-purple-400 to-pink-500",
  },
  {
    name: "UWE",
    image: UWE,
    fullName: "University of the West of England",
    location: "United Kingdom",
    ranking: "#39 in UK",
    scholarships: "6 Scholarships",
    employment: "92% Graduate Employment Rate",
    description:
      "UWE Bristol (University of the West of England) is a UK university known for its strong professional and vocational programs across business, engineering, health, and creative industries, with a focus on employability and industry links",
    courses: [
      {
        name: "Business / Business & Management / Accounting & Finance",
        fee: "GBP 16,000",
      },
      {
        name: "Engineering / Design / Environment / Computing & IT",
        fee: "GBP 16,500",
      },
      {
        name: "Health Sciences / Nursing / Allied‑Health / Health & Applied Sciences",
        fee: "GBP 16,750",
      },
      { name: "Postgraduate Degrees", fee: "GBP 16,000" },
    ],
    color: "from-pink-400 to-rose-500",
  },
  {
    name: "Huddersfield",
    image: UOH,
    fullName: "University of Huddersfield",
    location: "United Kingdom",
    ranking: "#524 QS World",
    scholarships: "7 Scholarships",
    employment: "98% Graduate Employment Rate",
    description:
      "University of Huddersfield is a UK university known for its strong industry-linked programs in engineering, business, media, and health, emphasizing employability and practical learning.",
    courses: [
      {
        name: "Business / Management / Accounting‑Finance / Marketing",
        fee: "GBP 15,500",
      },
      { name: "Engineering / Computing / Science / IT", fee: "GBP 15,500" },
      { name: "Health Sciences / Allied Health", fee: "GBP 15,500" },
      {
        name: "IArts / Design / Media / Creative & Humanities",
        fee: "GBP 15,500",
      },
    ],
    color: "from-amber-400 to-orange-500",
  },
  {
    name: "UON",
    image: UON,
    fullName: "University of Northampthon",
    location: "United Kingdom",
    ranking: "#119 in UK",
    scholarships: "5 Scholarships",
    employment: "96% Graduate Employment Rate",
    description:
      "University of Northampton is a UK university recognized for its strong focus on employability, innovative teaching, and professional programs in business, health, education, and social sciences.",
    courses: [
      { name: "Business & Management", fee: "GBP 15,200" },
      { name: "Computer Science / IT", fee: "GBP 15,200" },
      { name: "Health & Nursing", fee: "GBP 15,200" },
    ],
    color: "from-blue-400 to-cyan-500",
  },
  {
    name: "Coventry",
    image: Coventry,
    fullName: "Coventry University",
    location: "United Kingdom",
    ranking: "#531 QS World 2025",
    scholarships: "7 Scholarships",
    employment: "95% Graduate Employment Rate",
    description:
      "Coventry University is a UK university renowned for its industry-focused programs, strong employability outcomes, and global partnerships across business, engineering, health, and creative disciplines.",
    courses: [
      { name: "Engineering / Computing / Science", fee: "GBP 18,600" },
      { name: "Business & Management", fee: "GBP 16,800" },
      { name: "Health & Life Sciences", fee: "GBP 18,000" },
    ],
    color: "from-indigo-400 to-blue-500",
  },
];

export const footerData = {
  aboutTitle: "About SCS Education",
  aboutDesc:
    "SCS Education is Malaysia’s leading one-stop education service center, specializing in guidance for SPM, O-Level, STPM, UEC, and A-Level students — including course advice, university overviews, scholarship assistance, and career counseling.",
  partnerUniTitle: "Partner University",
  partnerUni: [
    "PSB",
    "Kaplan",
    "Amity",
    "EAIM",
    "MDIS",
    "Teesside",
    "USW",
    "UOS",
    "UWE",
    "Huddersfield",
    "UON",
    "Coventry",
  ],
  contactTitle: "Contact Info",
  contact: [
    "📞 Phone: 011-12870256",
    "✉️ Email: ng.scseducation@gmail.com",
    "📌 Office: Kuantan (HQ), Shah Alam, Sitiawan",
  ],
};
